import { render, staticRenderFns } from "./Starter.vue?vue&type=template&id=27d8062e&scoped=true&"
import script from "./Starter.vue?vue&type=script&lang=js&"
export * from "./Starter.vue?vue&type=script&lang=js&"
import style0 from "./Starter.vue?vue&type=style&index=0&id=27d8062e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27d8062e",
  null
  
)

export default component.exports